@media (--reefer-media-mobile-lg-max) {
  .image {
    display: none;
  }
}

/* Keeps the compare icon flowing inline with the surrounding text so the
   sentence reads continuously instead of breaking onto a new line. */
.inlineIcon {
  display: inline-flex;
  vertical-align: middle;
  margin: 0 8px;
}
